import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_251: DocMigration = {
  maxSchemaVersion: "0.0.251",
  description: "",
  apply(json: any) {
    for (const roomLayoutId in json.roomLayouts) {
      const roomLayout = json.roomLayouts[roomLayoutId];
      if (roomLayout.edgeDimensionBehavior !== undefined) {
        for (const dimensionBehavior of roomLayout.edgeDimensionBehavior) {
          if (dimensionBehavior.disableAuto !== undefined) {
            dimensionBehavior.disableInteriorAuto = dimensionBehavior.disableAuto;
            delete dimensionBehavior.disableAuto;
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_251;
